import styled from 'styled-components';

export const EditBuildingPage = styled.div`
    .inputs-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;
    }

    .small-input {
        padding: 15px;
        height: 50px;
    }

    .title-wrapper, .nickname-wrapper {
        margin-top: 20px;
        width: 66%
    }
`
